<template>
    <div class="text-white">
        <h1 class="text-center my-6">Add New Contact details</h1>
        <div v-if="Submited" class="mx-auto w-1/2 text-center mt-20">
            <p> {{ Resmessage }}  </p>
            <router-link to="/">
            <button class="bg-blue-900 text-white mt-10 px-4 py-2 rounded-lg "> Go to Home Page</button>
            </router-link>
        </div>
    <div class="md:w-1/2 mx-auto" v-if="formdisabled">
    <form @submit.prevent="createpost(Post)">
        <div class="mt-4 mx-2 flex flex-col bg-gray-900 rounded-xl p-4 ">
            
            <div class="relative transition duration-700 ease-in-out mb-2">
                <label class="text-gray-400" for="name">Provider Name ( required ) </label>
                <input id="name" v-model="Post.personName" @click="changelabel" minlength="4" autocomplete="" class="w-full my-2 hover:bg-blue-800  focus:bg-blue-800 border-none md:mx-auto rounded-lg text-gray-100 px-4 py-2 bg-gray-800" type="text" name="" required>
            </div>
            <div class="relative transition duration-700 ease-in-out mb-2">
                <label class="text-gray-400" for="no">Phone number ( required ) </label>
                <input id="no" type="tel" pattern="[0-9]+" minlength="10" maxlength="10" v-model="Post.personContactNo" autocomplete="" class="w-full my-2 hover:bg-blue-800  focus:bg-blue-800 border-none md:mx-auto rounded-lg text-gray-100 px-4 py-2 bg-gray-800" name="" required>
            </div>
            <div class="relative transition duration-700 ease-in-out mb-2">
               <div id="state" class="flex flex-row flex-wrap my-2">
                    <label class="w-52" :key="id" v-for="(resource , id) in currentResource">
                    <input :value="resource['_id']"
                     type="radio" name="resourceid" 
                     v-model="Post.resourceid" 
                     :id="resource['resourcceName']" required />
                    {{resource['resourceName']}} </label>
                </div>
            </div>
            <div class="relative transition duration-700 ease-in-out mb-2">
                <label class="text-gray-400" for="no">State ( required ) </label>
                <input required autocomplete="" class="w-full my-2 hover:bg-blue-800  focus:bg-blue-800 border-none md:mx-auto rounded-lg text-gray-100 px-4 py-2 bg-gray-800" 
                type="search" @change="updateState(statename)" v-model="statename" list="State" >
            </div>
                <datalist id="State">
                    <div :key="states._id" v-for="states in currentStates">
                        <option :value="states['Name']" /> 
                    </div>
                </datalist> 
            <div class="relative transition duration-700 ease-in-out mb-2">
                <label class="text-gray-400" for="no">City ( required ) </label>
                <input required autocomplete="" class="w-full my-2 hover:bg-blue-800  focus:bg-blue-800 border-none md:mx-auto rounded-lg text-gray-100 px-4 py-2 bg-gray-800" 
                type="search" @change="updateCity(cityName)" v-model="cityName" list="City" >
            </div>
                    <datalist id="City">
                        <div :key="city._id" v-for="city in currentCity">
                        <div v-if="city['State']['_id'] == Post.stateId"> 
                                <option :value="city['Name']" > {{ city['Name'] }} </option>
                            </div>
                        </div>
                    </datalist> 

            <div id="state" class="relative transition duration-700 ease-in-out mb-2">
                <label class="text-gray-400" for=""> Provider's Address </label>
                <input v-model="Post.address" placeholder="Gomti Nagar, Lucknow 226010" autocomplete="" class="w-full my-2 hover:bg-blue-800 focus:bg-blue-800 border-none md:mx-auto rounded-lg text-gray-100 px-4 py-2 bg-gray-800" type="text" name="" >
            </div>
            <div id="state" class="relative transition duration-700 ease-in-out mb-2">
                    <label class="w-52">
                    <input value=""  type="checkbox" name="resourceid" 
                     v-model="Post.verified" /> Verified Contact </label>
            </div>

            <div class="relative transition duration-700 ease-in-out mb-2">
                <label class="text-gray-400" for="">Source Link </label>
                <input  v-model="Post.sourceLink" placeholder="https://" autocomplete="" class="w-full my-2 mb-2 hover:bg-blue-800  focus:bg-blue-800 border-none md:mx-auto rounded-lg text-gray-100 px-4 py-2 bg-gray-800" type="text" name="" >
            </div>
            <div class="relative transition duration-700 ease-in-out mb-2">
                <label class="text-gray-400" for="">Other Information </label>
                <input v-model="Post.otherInfo" placeholder="phone number is active, Oxygen refill only" autocomplete="" class="w-full my-2 hover:bg-blue-800  focus:bg-blue-800 border-none md:mx-auto rounded-lg text-gray-100 px-4 py-2 bg-gray-800" type="text" name="" >
            </div>
            <div class="relative transition duration-700 ease-in-out mb-2">
                <label class="text-gray-400" for="">Your Email Address ( required ) </label>
                <input required v-model="Post.postedBy" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" placeholder="youremail@gmail.com" autocomplete=""   class="w-full my-2 hover:bg-blue-800  focus:bg-blue-800 border-none md:mx-auto rounded-lg text-gray-100 px-4 py-2 bg-gray-800" type="email" name="" >
            </div>
            <button type="submit" class="bg-blue-800 text-white px-4 mt-2 py-2 rounded-lg">Submit details</button>
        </div>
    </form>
    </div>
    </div>
</template>

<script>
import { mapState , mapActions , mapGetters} from 'vuex'
import axios from 'axios'
   
export default {
    name : "Addresources",
    computed:{
      ...mapState(['currentCity','currentResource','currentStates']),
      ...mapGetters(['getCurrentResource'])
  },
    data() {
        return{
            formdisabled : true,
            Submited : false,
            statename : '',
            cityName : '',
            Resmessage : "Your Details has been submited, thanks for helping",
            Post : {
                personName : null,
                personContactNo : null,
                resourceid : null,
                stateId: null,
                cityId: null,
                verified : false,
                address : null,
                postedBy : null,
                otherInfo : null,
                sourceLink : null
            }
        }
    },
    props:{
        resourceid :String
    },
    mounted() {
        this.fetchResources()
        this.fetchState()
        this.fetchCity()
    },
    async created(){
    },
     methods : {
         ...mapActions(['fetchCity', 'fetchResources', 'fetchState']),

         updateState(statename){
            try{
              for( let i in this.currentStates ){
                if(statename === this.currentStates[i]['Name']){
                 this.Post['stateId']  = this.currentStates[i]['_id']
                 break
                }
              }
            } catch(error){console.log(error)}
         },
         updateCity(cityName){
            try{
              for( let i in this.currentCity ){
                  
                if(cityName === this.currentCity[i]['Name']){
                    this.Post['cityId']  = this.currentCity[i]['_id']
                    break
                }
              }
            } catch(error){console.log(error)}
         },
        async createpost(post) {
            let axiosConfig = {
                headers : { "Content-Type": "application/json" }
            };
            var body = JSON.stringify({ 
                stateId : post.stateId ,
                cityId : post.cityId,
                personName : post.personName,
                personContactNo : post.personContactNo,
                resource : post.resourceid,
                address : post.address,
                approved : post.verified,
                otherInfo : post.otherInfo,
                postedBy : post.postedBy,
                links : post.sourceLink
            });
            const response = await axios.post("https://helpinghands-backend.herokuapp.com/posts/createpost", body ,  axiosConfig );
            const data = await response;
            let res = data['data']['code']
            if(res === 200){
                this.Resmessage = "Your Details has been submited, thanks for helping"
                alert(this.Resmessage)
                this.formdisabled = !this.formdisabled
                this.Submited = !this.Submited
            }
            else if(res === 403){
                this.Resmessage = "Please Fill all Details correctly"
                this.Submited = !this.Submited
                alert("error submiting Form, Please Fill all Details correctly")
            }
            
        }   
    }
}
</script>